
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'burger-button',

	emits: ['active'],

	props: {
		active: {
			type: Boolean
		}
	},

	methods: {
		toggle() {
			this.$emit('active', !this.active);
		}
	}
});
